export default "__VITE_ASSET__C335z5ea__"